<template lang="html">
  <footer v-observe-visibility="{
    callback: visibilityChanged,
    throttle: 300
    }"
    >
    <div class="footer-cols footer-negative" >
      <div class="footer-mask">
        
      </div>
    </div>
    <div class="footer-cols footer-positive" :class="isVisible ? 'enter' : ''">
      <div class="footer-left">
        <h3 v-html="$t('message.footer_title')"></h3>
        <img src="../../assets/images/arrow-footer-positive@2x.png" />
      </div>
      <div class="footer-right">
        <div class="footer-right-col" >
          <div class="image-wrap">
            <img src="../../assets/images/footer-logo-maire.png" alt="Maire MyReplast">
          </div>
          <div >
            <b>{{$t("message.footer_col_1_title_legal")}}</b>
            <br>{{$t("message.footer_col_1_address_legal")}}<br>
            <span class='phone'></span>+39 030 6871152 
            <span class='fax'></span>+39 030 6874933<br>
            <a href='mailto:info@myreplastindustries.it' target='_blank'>info@myreplastindustries.it</a>
          </div>
        </div>
        <div class="footer-right-col" >
          <div class="image-wrap">
            <img src="../../assets/images/footer-logo-next.png" alt="Maire MyReplast">
          </div>
          <div v-html="$t('message.footer_col_2')"></div>
        </div>
        <div class="footer-right-col" >
          <img src="../../assets/images/empty-col.png" alt="Maire MyReplast">
          <div v-html="$t('message.footer_col_5')"></div>
          <div v-html="$t('message.footer_col_3')"></div>
          <div v-html="$t('message.footer_col_4')"></div>
          
            <a :href="$t('message.privacy_link')"" >
              <span class="menu-item sub-item">{{ $t("message.footer_col_3_privacy_text") }}</span>
            </a>
                     
            <br>
            <a :href="$t('message.cookie_link')""

            >
              <span class="menu-item sub-item">{{ $t("message.footer_col_3_cookie_text") }}</span>
            </a>
            <div v-html="$t('message.footer_col_whistleblowing')"></div>
      
            <br/>
            © 2023 Nextchem
        </div>
      </div>
      <div class="legals--wrapper">
        <a href='#' class='iubenda-cs-preferences-link'>  
          <img style='width: 2rem' src="../../assets/images/iubenda-pref.svg" alt="California Consumer Privacy Act (CCPA) Opt-Out Icon"/> Le tue preferenze relative alla privacy
        </a>
        <br/><br/>
        <p v-html="$t('message.footer_legals_bottom')"></p>
      </div>
    </div>

    
  </footer>
</template>

<script>
export default {
  name: "Footer",
  props: ["lang"],
  data() {
    return {
      isVisible: false,
    };
  },
  methods: {
    visibilityChanged: function (isVisible, entry) {
      if (isVisible) {
        this.isVisible = true;
      } else {
        this.isVisible = false;
      }
    },
  },
  watch: {
    lang(laang) {},
  },
};
</script>

<style lang="scss">
footer {
  position: relative;
  padding: 0;
  overflow: hidden;
  margin-top: 100px;
  z-index: 3;
  .footer-cols {
    position: relative;
    top: 0;
    display: flex;
    padding: 140px 120px 120px;
    flex-direction: row;
    align-items: self-start;
    right: 0;
    left: 0;
    justify-content: space-between;
    @media screen and( max-width: 1100px) {
      padding: 100px 60px 100px;
    }
    @media screen and( max-width: 900px) {
      padding: 30px 20px 30px;
      flex-direction: column;
    }
    &.footer-positive {
      position: relative;
      background-color: #fff;
      clip-path: inset(100% 0 0 0);
      transition: clip-path 0s linear;
      border-top: 1px solid #396077;
      &.enter {
        clip-path: inset(0% 0 0 0);
        transition: clip-path 0.15s ease-out;
      }
      .footer-mask {
        position: relative;
        width: 100%;
        display: flex;
        flex-direction: row;
        align-items: self-start;
        justify-content: space-between;
        h3 {
          color: #396077;
        }
        @media screen and( max-width: 900px) {
          flex-direction: column;
        }
      }
    }
    &.footer-negative {
      position: absolute;
      background-color: #396077;
      color: #fff;
      height: 100%;
    }
    .footer-left {
      width: 25%;
      @media screen and( max-width: 900px) {
        width: 100%;
        text-align: center;
      }
      h3 {
        font-size: 30px;
        line-height: 30px;
        margin-bottom: 20px;
        @media screen and( max-width: 900px) {
          font-size: 20px;
          line-height: 30px;
        }
      }
      img {
        width: 30px;
      }
    }
    .footer-right {
      width: 75%;
      display: flex;
      align-items: flex-start;
      flex-direction: row;
      justify-content: space-around;
      line-height: 30px;
      font-size: 14px;
      padding-bottom: 50px;
      .footer-right-col {
        width: 30%;
        &:nth-child(1) {
          width: 40%;
          margin-right: 10px;
        }
        &:nth-child(3) {
          a {
            text-decoration: underline;
          }
        }
        .image-wrap {
          width: 100%;
          height: 100px;
          display: flex;
          align-items: flex-start;
          justify-content: flex-start;
        }
        img {
          height: 80px;
          padding-bottom: 15px;
        }
        &:nth-child(2) {
          img {
            height: 75px;
          }
        }
      }
      @media screen and( max-width: 900px) {
        margin-top: 50px;
        width: 100%;
        justify-content: space-between;
        flex-wrap: wrap;
        font-size: 16px;
        text-align: center;
        .footer-right-col {
          width: 100%;
          margin-bottom: 20px;
          &:nth-child(1),
          &:nth-child(2),
          &:nth-child(3) {
            width: 100%;
            .image-wrap {
              height: auto;
              justify-content: center;
              img {
                height: 80px;
              }
            }
          }
          &:nth-child(3) {
            img {
              display: none;
            }
          }
        }
      }
    }
  }
  .phone {
    display: inline-block;
    width: 10px;
    height: 10px;
    margin-right: 5px;
    &:after {
      content: "";
      background-image: url("../../assets/images/phone@2x.png");
      background-size: 10px 10px;
      background-size: 10px 10px;
      width: 10px;
      height: 10px;
      position: relative;
      display: block;
    }
  }
  .fax {
    display: inline-block;
    width: 10px;
    height: 10px;
    margin: 0 5px;
    &:after {
      content: "";
      background-image: url("../../assets/images/fax@2x.png");
      background-size: 10px 10px;
      background-size: 10px 10px;
      width: 10px;
      height: 10px;
      position: relative;
      display: block;
    }
  }
  .legals--wrapper {
    position: absolute;
    bottom: 0;
    padding-right: 140px;
    font-size: 12px;
    a.iubenda-cs-preferences-link {
      display: flex;
      align-items: center;
      justify-content: flex-start;
      img {
        margin-right: 10px;
      }
    }
    p {
      padding-bottom: 50px;
    }
    @media screen and( max-width: 900px) {
      position: relative;
      padding: 0;
    }
  }
}
</style>



// WEBPACK FOOTER //
// Footer.vue?ef96ebe6